import { Box, Button, Card, CardContent, Chip, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Api from "../../../Api";
import { IADUser } from "../../../interfaces";
import { FormSectionHeader } from "../../Shared/FormSectionHeader";

export const ApprovalActions = (
    allowed: boolean,
    valid: boolean,
    approverRole: string,
    approveCallback: (commercialUserId?: string, platformEngineerId?: string) => void,
    rejectCallback: (r: string) => void,
    approvers?: (string | null | undefined)[],
    commercialApprovedDate?: string,
    platformEngineerApprovedDate?: string
) => {

    const [reasonPrompt, setReasonPrompt] = useState(false);
    const [commercialPrompt, setCommercialPrompt] = useState(approverRole === "Asset Protection" ? false : undefined);
    const [platformEngineerPrompt, setPlatformEngineerPrompt] = useState(approverRole === "Asset Protection" ? false : undefined);
    const [reason, setReason] = useState("");
    const [commercialUser, setCommercialUser] = useState<string | undefined>();
    const [platformEngineer, setPlatformEngineer] = useState<string | undefined>();
    const [usersS, setUsersS] = useState<IADUser[]>([]);
    const [usersC, setUsersC] = useState<IADUser[]>([]);

    const [loading, setLoading] = useState(false);

    const handleCommercial = () => {
        setLoading(true);
        setCommercialPrompt(true);

        if (usersC.length === 0)
            loadCommercial();
        else
            setLoading(false);
    };

    const handlePlatformEngineer = () => {
        setLoading(true);
        setPlatformEngineerPrompt(true);

        if (usersS.length === 0)
            loadPlatformEngineer();
        else
            setLoading(false);
    };

    const cancelCommercial = () => {
        setCommercialUser(undefined);
        setCommercialPrompt(false);
    };

    const cancelPlatformEngineer = () => {
        setPlatformEngineer(undefined);
        setPlatformEngineerPrompt(false);
    };

    const loadCommercial = () => {
        Api.Users.getAll().then(userResult => {
            var adUsers = userResult as IADUser[];
            setUsersC(adUsers.filter(x => x.role?.value === "InternalCommercial" || x.email?.toLowerCase() === "eric.riley@syntaxits.com"));
            setLoading(false);
        });
    }

    const loadPlatformEngineer = () => {
        Api.Users.getAll().then(userResult => {
            var adUsers = userResult as IADUser[];
            setUsersS(adUsers.filter(x => x.role?.value === "InternalStandard" || x.email?.toLowerCase() === "eric.riley@syntaxits.com"));
            setLoading(false);
        });
    }

    useEffect(() => {
        if (usersC.length === 0) {
            setLoading(true);
            loadCommercial();
            loadPlatformEngineer();
        }
    }, [approvers])

    const ApproversDetail = () => {
        return <>
            {approvers &&
                <Grid container sx={{ my: 3 }}>
                    {
                        approvers[0] ?
                            <Grid item md={12} xs={12}>
                                {loading ? (
                                    <CircularProgress />
                                ) : (
                                    <Typography>
                                        Commercial Approval Required By <strong>{usersC.filter(x => x.id === approvers[0])[0]?.name}</strong>
                                            {commercialApprovedDate && <Chip sx={{ ml: 2 }} color="primary" label="Approved" />}
                                    </Typography>

                                )}
                            </Grid>
                            : <></>
                    }
                    {
                        approvers[1] ?
                            <Grid item md={12} xs={12}>
                                {loading ? (
                                    <CircularProgress />
                                ) : (
                                    <Typography>
                                        Platform Engineer Approval Required By <strong>{usersS.filter(x => x.id === approvers[1])[0]?.name}</strong>
                                        {platformEngineerApprovedDate && <Chip label="Approved" />}
                                    </Typography>

                                )}
                            </Grid>
                            : <></>
                    }

                </Grid>
            }
        </>
    }

    return (
        <Card>
            <FormSectionHeader label="Request Approval" />
            {allowed === true ? (
                <CardContent>

                    <Typography variant="subtitle1">
                        All requested material must be assigned before the request can be approved. <br />Please assess the materials in this dispatch request and either <strong>Approve</strong> or <strong>Reject</strong> the request.
                    </Typography>

                    {commercialPrompt === false && (
                        <Box sx={{}}>
                            <Button variant="contained" onClick={handleCommercial}>
                                Requires Commercial Approval
                            </Button>
                        </Box>
                    )}

                    {commercialPrompt === true && (
                        <Box sx={{ my: 2 }}>
                            <Typography variant="subtitle1">
                                If commercial approval is required for this dispatch request, please select from the available users to request approval from.
                            </Typography>
                            <Grid container sx={{ my: 3 }}>
                                <Grid item md={6} xs={12}>
                                    {loading ? (
                                        <CircularProgress />
                                    ) : (
                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                            <InputLabel id="commercial-user-select-label">Commercial User</InputLabel>
                                            <Select
                                                labelId="commercial-user-select-label"
                                                value={commercialUser}
                                                label="Commercial User"
                                                onChange={(e) => setCommercialUser(e.target.value)}
                                            >
                                                <MenuItem value={undefined}></MenuItem>
                                                {usersC.map(x => (
                                                    <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                </Grid>
                            </Grid>
                            <div>
                                <Button variant="outlined" color="warning" onClick={cancelCommercial}>
                                    Not Required
                                </Button>
                            </div>
                        </Box>
                    )}

                    {platformEngineerPrompt === false && (
                        <Box sx={{ my: 2 }}>
                            <Button variant="contained" onClick={handlePlatformEngineer}>
                                Requires Platform Engineer Approval
                            </Button>
                        </Box>
                    )}

                    {platformEngineerPrompt === true && (
                        <Box sx={{ my: 2 }}>
                            <Typography variant="subtitle1">
                                If platform engineer approval is required for this dispatch request, please select from the available users to request approval from.
                            </Typography>
                            <Grid container sx={{ my: 3 }}>
                                <Grid item md={6} xs={12}>
                                    {loading ? (
                                        <CircularProgress />
                                    ) : (
                                        <FormControl fullWidth sx={{ mt: 1 }}>
                                            <InputLabel id="platform-engineer-select-label">Platform Engineer</InputLabel>
                                            <Select
                                                labelId="platform-engineer-select-label"
                                                value={platformEngineer}
                                                label="Platform Engineer"
                                                onChange={(e) => setPlatformEngineer(e.target.value)}
                                            >
                                                <MenuItem value={undefined}></MenuItem>
                                                {usersS.map(x => (
                                                    <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                </Grid>
                            </Grid>
                            <div>
                                <Button variant="outlined" color="warning" onClick={cancelPlatformEngineer}>
                                    Not Required
                                </Button>
                            </div>
                        </Box>
                    )}

                    <ApproversDetail />


                    <Button
                        variant="contained"
                        onClick={() => approveCallback(commercialUser, platformEngineer)}
                        disabled={(!valid) || reasonPrompt || (commercialPrompt && !commercialUser) || (platformEngineerPrompt && !platformEngineer)}>
                        Approve
                    </Button>
                    <Button variant="outlined" onClick={() => setReasonPrompt(true)} disabled={reasonPrompt || commercialPrompt || platformEngineerPrompt}>
                        Reject
                    </Button>

                    {reasonPrompt && (
                        <Box sx={{ my: 2 }}>
                            <Typography variant="subtitle1">
                                To <strong>Reject</strong> this request, please provide a reason
                            </Typography>
                            <Grid container sx={{ my: 3 }}>
                                <Grid item md={6} xs={12}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        required
                                        label="Reason"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)} />
                                </Grid>
                            </Grid>
                            <div>
                                <Button
                                    variant="contained"
                                    color="warning" onClick={() => rejectCallback(reason)}
                                    disabled={reason.length === 0}
                                >
                                    Confirm Rejection
                                </Button>
                                <Button variant="outlined" color="warning" onClick={() => setReasonPrompt(false)}>
                                    Cancel
                                </Button>
                            </div>
                        </Box>
                    )}

                </CardContent>
            ) : (
                <CardContent>
                    <Typography variant="subtitle1" color="GrayText">
                        This dispatch request is awaiting approval. There are currently no further actions available.
                    </Typography>
                    <ApproversDetail />
                </CardContent>
            )}
        </Card>
    );
};
